export class MachinesExportRequest {

    _page; // number
    _term; // string
    _companyId; // number
    _machineStateIds; // number[]

    constructor(companyId = undefined) {
        this._page = 1;
        this._term = '';
        this._companyId = companyId;
        this._machineStateIds = undefined;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setMachineState(machineState) {
        this._machineStateIds =
            machineState === 1 || machineState === 2
                ? [machineState]
                : undefined;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                company_id: this._companyId,
                machine_state_ids: this._machineStateIds,
                show_only_deleted: false,
                include_only_company_machines: true,
                include_only_contractor_machines: undefined,
                retrieve_machine_documentation_state: true,
                skip_contractors_inactive: true,
                skip_companies_inactive: true,
            },
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/list/machines-export/MachinesExportRequest.js